import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { TranslateModule } from '@ngx-translate/core';

import { DarkModeService } from '../../core/services/dark-mode.service';
import { MessagingMaterialModule } from '../material/material';
import { AlertModalComponent } from './components/alert/alert.component';
import { DarkModeComponent } from './components/dark-mode-toggle/dark-mode-toggle.component';
import { LogoutComponent } from './components/logout/logout.component';
import { MessagingAvatarComponent } from './components/messaging-avatar/messaging-avatar.component';
import { PhotoPreviewComponent } from './components/photo-preview/photo-preview.component';
import { ProfileModalComponent } from './components/profile-modal/profile-modal.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TokenErrorComponent } from './components/token-error/token-error.component';
import { DirectivesModule } from './directives/directives.module';
import { ImagesService } from './services/images.service';

@NgModule({
  declarations: [
    TokenErrorComponent,
    SidebarComponent,
    LogoutComponent,
    DarkModeComponent,
    ProfileComponent,
    AlertModalComponent,
    ProfileModalComponent,
    PhotoPreviewComponent,
    MessagingAvatarComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MessagingMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    InfiniteScrollModule,
  ],
  exports: [
    TokenErrorComponent,
    FormsModule,
    ReactiveFormsModule,
    LogoutComponent,
    MessagingAvatarComponent,
    MessagingMaterialModule,
    DarkModeComponent,
    SidebarComponent,
    ProfileComponent,
    AlertModalComponent,
    ProfileModalComponent,
    InfiniteScrollModule,
    DirectivesModule,
    PhotoPreviewComponent,
  ],
  providers: [DarkModeService, ImagesService],
})
export class NgxMessagingSharedModule {}
